import { Fragment } from 'react';
import { useFormikContext } from 'formik';

import { CollapsibleSection } from '../../Form/CollapsibleSection/CollapsibleSection';
import { Input } from '../../Form/Input/Input';
import { ImageUploadInput } from '../../Form/ImageUploadInput/ImageUploadInput';

import type { ComponentInput } from '../../../types';

import styles from '../ComponentForm.module.scss';

type Props = {
  inputsSize: string;
};

function SplashFields({ inputsSize }: Props) {
  const { values } =
    useFormikContext<Partial<ComponentInput & { id: string }>>();

  const dataType = values?.data?.type;
  const dataTypeLabel = dataType === 'assets' ? 'asset' : 'category';

  return (
    <Fragment>
      <CollapsibleSection label="Options" initiallyCollapsed={false}>
        <Input label="Button label" name="options.buttonLabel" size="small" />
      </CollapsibleSection>
      <CollapsibleSection
        label="Overrides (optional)"
        initiallyCollapsed={false}
      >
        <p className={styles.splashOverrides}>
          Use these to override the selected {dataTypeLabel} details, or use
          them when no {dataTypeLabel} is selected.
        </p>
        <Input type="text" label="Title" name="overrides.title" size="small" />
        <Input
          type="text"
          label="External url"
          name="overrides.url"
          size="small"
        />
        <Input
          type="textarea"
          label="Description"
          name="overrides.description"
          size={inputsSize}
        />
        <ImageUploadInput
          name="overrides.image"
          label="Image"
          aspectRatio={16 / 9}
        />
      </CollapsibleSection>
    </Fragment>
  );
}

export { SplashFields };
